import React from "react";
import Ajax, { domain } from "../ajax/Ajax";
import { Loading } from "../../App";
import logo from "../../images/logo.png";
import { Helmet } from "react-helmet/es/Helmet";

class AllStocks extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stocks: [],
      fetching: true,
      fetchingTotal: false,
      nextFetch: null,
      prevFetch: null,
      stockValue: 0,
      currency: "",
    };

    this.fetchPage = this.fetchPage.bind(this);
    this.getStocksTotal = this.getStocksTotal.bind(this);
    this.fetchTotalValue = this.fetchTotalValue.bind(this);
  }

  async fetchTotalValue() {
    let param = "?stock_value=true&";
    if (this.props.focusObj) {
      param += "focus=" + this.props.focus;
      param += "&focus_id=" + this.props.focusObj.token;

      this.setState({ fetchingTotal: true });
      let fetchResults = await Ajax.fetchData(
        domain + "/en/api/shop/v1/all-stocks/" + param
      );
      console.log(fetchResults);
      if (fetchResults) {
        this.setState({
          stockValue: fetchResults.value,
          currency: fetchResults.currency,
          fetchingTotal: false,
        });
      }
    }
  }

  async fetchPage(page) {
    if (!this.state.fetching) {
      let url = "";
      if (page === "next") {
        url =
          domain + this.state.nextFetch.replace("http://127.0.0.1:8001", "");
      } else {
        url =
          domain + this.state.prevFetch.replace("http://127.0.0.1:8001", "");
      }

      console.log("fetching more ...");
      this.setState({ fetching: true });
      let fetchResults = await Ajax.fetchData(url);

      if (fetchResults) {
        await this.setState({
          stocks: fetchResults.results,
          nextFetch: fetchResults.next,
          prevFetch: fetchResults.previous,
          fetching: false,
        });
      }
    }
  }

  async fetchStocks() {
    let param = "?";

    if (this.props.focusObj) {
      param += "focus=" + this.props.focus;
      param += "&focus_id=" + this.props.focusObj.token;

      this.setState({ fetching: true });
      let fetchResults = await Ajax.fetchData(
        domain + "/en/api/shop/v1/all-stocks/" + param
      );
      console.log(fetchResults);
      if (fetchResults) {
        this.setState({
          stocks: fetchResults.results,
          nextFetch: fetchResults.next,
          prevFetch: fetchResults.previous,
          fetching: false,
        });
      }

      this.fetchTotalValue();
    }
  }

  async componentDidMount() {
    await this.fetchStocks();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    try {
      if (this.props.focusObj.token !== prevProps.focusObj.token) {
        this.fetchStocks();
      }
    } catch (e) {
      console.log(e);
    }
  }

  getStocksTotal() {
    let total = 0;
    let currency = "";
    this.state.stocks.forEach((stock) => {
      total += stock.item.price * stock.item.stock;
      stock.shop
        ? (currency = stock.shop.currency)
        : (currency = stock.warehouse.currency);
    });
    return currency + " " + total.toLocaleString();
  }

  render() {
    return (
      <div>
        <Helmet>
          <link rel="icon" href={logo} />
          <title>Stock | VehShop</title>
        </Helmet>
        {this.state.fetching && this.state.stocks.length < 1 ? (
          <div>
            <Loading />
          </div>
        ) : (
          <div>
            <div className="card is-shadowless bordered-card animated fadeIn">
              <div className="card-content">
                <div>
                  <div className="title has-text-centered">Stocks</div>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="animated fadeIn">
                    <div>
                      {this.state.fetchingTotal ? (
                        <div className="d-flex justify-content-center">
                          <Loading />
                        </div>
                      ) : (
                        <div>
                          {this.state.stockValue ? (
                            <span>
                              Total Value:{" "}
                              <strong>
                                {this.state.currency}{" "}
                                {this.state.stockValue.toLocaleString()}
                              </strong>
                            </span>
                          ) : (
                            <span></span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    Page Value: <strong>{this.getStocksTotal()}</strong>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="d-flex justify-content-between">
                    <div>
                      <button
                        onClick={() => {
                          this.fetchPage("previous");
                        }}
                        title="Previous Page"
                        disabled={this.state.prevFetch ? false : true}
                        className="button"
                      >
                        <span className="fas fa-angle-left mr-1"></span>
                        <span>Previous</span>
                      </button>
                    </div>

                    <div>
                      <button
                        onClick={() => {
                          this.fetchPage("next");
                        }}
                        title="Next Page"
                        disabled={this.state.nextFetch ? false : true}
                        className="button"
                      >
                        <span className="mr-1">Next</span>
                        <span className="fas fa-angle-right"></span>
                      </button>
                    </div>
                  </div>
                </div>

                {this.state.fetching ? (
                  <div className="animated fadeIne">
                    <Loading />
                    <br />
                  </div>
                ) : (
                  <div></div>
                )}
                <div className="overflow-auto">
                  <table className="table is-fullwidth is-stripped is-hoverable mt-4">
                    <thead>
                      <tr>
                        <td>Product</td>
                        <td>Unit Price</td>
                        <td>Stock</td>
                        <td>Value</td>
                        <td>Init</td>
                      </tr>
                    </thead>

                    <tbody>
                      {this.state.stocks.map((stock) => (
                        <tr key={stock.item.id + "-all-stocks"}>
                          <td>{stock.item.name}</td>
                          <td>
                            {stock.shop ? (
                              <span>{stock.shop.currency}</span>
                            ) : (
                              <span>{stock.warehouse.currency}</span>
                            )}{" "}
                            {stock.item.price.toLocaleString()}
                          </td>
                          <td>
                            {stock.item.stock < 1 ? (
                              <span className="has-text-danger">
                                {stock.item.stock} {stock.item.unit}
                              </span>
                            ) : (
                              <span>
                                {stock.item.stock} {stock.item.unit}
                              </span>
                            )}
                          </td>
                          <td>
                            {stock.shop ? (
                              <span>{stock.shop.currency}</span>
                            ) : (
                              <span>{stock.warehouse.currency}</span>
                            )}{" "}
                            {(
                              stock.item.stock * stock.item.price
                            ).toLocaleString()}
                          </td>
                          <td>
                            {stock.shop ? (
                              <span>{stock.item.init}</span>
                            ) : (
                              <span>0</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AllStocks;
